import React from 'react';
import { batch } from 'react-redux';
import { pushReportApi } from 'services/api/pushReportApi';
import { errorMessagesUtils } from 'services/utils';
import { addIndication, INDICATION_TYPES } from '../../taboola-common-frontend-modules/Indications';
import { FormattedMessage } from '../../taboola-common-frontend-modules/i18n';
import { updatePushApiSubscription, updatePushApiSubscriptionError } from '../actions/requestUpdatePushApiSubscription';

export const successIndication = {
    message: (
        <FormattedMessage
            id="push.api.update.state.success"
            defaultMessage="Push API subscription state successfully updated."
        />
    ),
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: (
        <FormattedMessage
            id="push.api.update.state.error.highlight"
            defaultMessage="Unable to update Push API subscription state."
        />
    ),
});

export const updatePushApiState =
    ({ accountId, subscription, onError }) =>
    async dispatch => {
        try {
            const updateSubscriptionResponse = await pushReportApi.updatePushReport(accountId, subscription.id, {
                isActive: subscription.isActive,
            });

            batch(() => {
                dispatch(updatePushApiSubscription({ ...updateSubscriptionResponse, accountId }));
                dispatch(addIndication(successIndication));
            });
            return updateSubscriptionResponse;
        } catch (error) {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(updatePushApiSubscriptionError(error));
            if (onError) {
                onError();
            }
        }
    };
